module.exports = __webpack_public_path__ + "static/img/4.f1b776e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/4.png
// module id = hnmu
// module chunks = 1